import { useEffect, useState, useContext } from "react";
import { ClientContext } from "ClientProvider";
import { getSingleRole } from "api/graphQL_role";
import { getId } from "utils/auth";
import BlackList from "./components/BlackList";
import CreateBlockClientsModal from "./components/CreateBlockeclientModal";
import { getAllBlackList } from "api/blackListClient";

export type BlackListClientsRowObj = {
  id: string;
  created_at: string;
  first_name: string;
  last_name: string;
  email?: string;
  is_blacklisted?: boolean;
  bin: string;
  last_four: string;
  attempts?: string;
};

const BlackListClients = () => {
  const [blackListClients, setBlackListClients] = useState<BlackListClientsRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const { singleRoleData, setSingleRoleData, filter, setFilter } = useContext(ClientContext);

  const fetchBlackListClientsData = () => {
    setIsLoading(true);
    getAllBlackList(page, pageSize, searchTexts)
      .then((data) => {
        setBlackListClients(data[0]);
        setTotalPage(data[1]?.total_pages);
        setTotalItems(data[1]?.total_items);
        setCurrentPage(data[1]?.current_page);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  useEffect(() => { fetchBlackListClientsData(); }, [page, pageSize, filter, searchTexts]);
  useEffect(() => { setPageSize(50); }, [searchTexts]);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1); setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  return (
    <div className="bl-root">
      {/* Page header */}
      <div className="bl-page-header">
        <div className="bl-title-block">
          <div className="bl-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
            </svg>
          </div>
          <div>
            <h1 className="bl-heading">Blacklist</h1>
            <p className="bl-sub">Manage blocked clients, cards and email addresses</p>
          </div>
        </div>
        {/* {singleRoleData?.[0]?.blacklist?.value?.add_blacklist && (
          <div className="bl-page-actions">
            <CreateBlockClientsModal
              fetchBlackListClientsData={fetchBlackListClientsData}
              roleData={singleRoleData}
            />
          </div>
        )} */}
      </div>

      <BlackList
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        roleData={singleRoleData}
        tableData={blackListClients}
        fetchBlackListClientsData={fetchBlackListClientsData}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        onValueChange={serchboxValueChange}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .bl-root { font-family:'Plus Jakarta Sans',sans-serif; display:flex; flex-direction:column; gap:20px; }
        .bl-page-header { display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:16px; }
        .bl-title-block { display:flex; align-items:center; gap:14px; }
        .bl-page-icon { width:44px; height:44px; border-radius:12px; background:linear-gradient(135deg,#fff1f2,#ffe4e6); border:1.5px solid #fecdd3; display:flex; align-items:center; justify-content:center; color:#e11d48; flex-shrink:0; }
        .bl-heading { font-size:20px; font-weight:800; color:#0f172a; letter-spacing:-0.4px; margin-bottom:2px; line-height:1.2; }
        .bl-sub { font-size:13px; color:#94a3b8; font-weight:500; }
        .bl-page-actions { display:flex; gap:10px; align-items:center; }
      `}</style>
    </div>
  );
};

export default BlackListClients;